import { axios, transformAxiosError } from "../utils/axios.create";
import {
  GroupLabel,
  OrganizationPayload,
  OrganizationsResponse,
  SearchOrganizationsPayload,
} from "../domain/organizations.interface";

const findByIds = async ({
  ids,
  status,
}: {
  ids: string[];
  status: string;
}): Promise<OrganizationsResponse> => {
  const statusQuery = new URLSearchParams({
    status: status,
    _id: ids.join(","),
  }).toString();

  return axios
    .get(`/organizations?${statusQuery}`)
    .then((res) => {
      return res.data.body;
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findAll = async (): Promise<OrganizationsResponse> => {
  return axios
    .get("/organizations")
    .then((res) => {
      return res.data.body;
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const search = async ({
  search,
  sortField,
  sortOrder,
  pageNumber,
  pageSize,
}: SearchOrganizationsPayload): Promise<OrganizationsResponse> => {
  const queryParams = new URLSearchParams({
    pageNumber: String(pageNumber + 1),
    pageSize: String(pageSize),
    search,
    sortField,
    sortOrder: sortOrder === 1 ? "asc" : "desc",
  });

  return axios
    .get(`/organizations/search?${queryParams.toString()}`)
    .then((res) => {
      const body = res.data.body;
      return {
        organizations: body.organizations,
        totalCount: body.totalCount,
      };
    })
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const findOrganizationGroupLabels = async (): Promise<GroupLabel[]> => {
  return axios
    .get("/organizations/group-labels")
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const create = async (data: OrganizationPayload) => {
  return axios
    .post("/organizations", data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const update = async ({
  id,
  data,
}: {
  id: string;
  data: OrganizationPayload;
}) => {
  return axios
    .put(`/organizations/${id}`, data)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

const softDelete = async (id: string) => {
  return axios
    .delete(`/organizations/${id}`)
    .then((res) => res.data.body)
    .catch((err) => {
      return Promise.reject(transformAxiosError(err));
    });
};

export const OrganizationService = {
  findByIds,
  search,
  findAll,
  findOrganizationGroupLabels,
  create,
  update,
  softDelete,
};
